import React, { Component } from 'react'

export default class Switch extends Component {
    render() {
        const { value, setValue, id, dataAtt } = this.props
        return (
            <span className="switch justify-content-center">
                <label className='d-flex' htmlFor={id} data-test-id={dataAtt}>
                    {/* <input type="hidden" id="feeds179667moderation_" value="0" /> */}
                    <input
                        type="checkbox"
                        id={id}
                        className="onoffswitch-checkbox updateStatus"
                        defaultChecked={value}
                        onChange={(e) => setValue(e.target.checked)}
                    />
                    <span></span>
                </label>
            </span>
        )
    }
}
